<template>
  <page-list
    :list="list"
    :columns="showColumns"
    :group-actions="groupActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import * as R from 'ramda'
import { RuleTypes } from '@Bill/constants'
import expectStatus from '@/constants/expectStatus'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getBrandFilter, getTenantFilter, getAccountFilter, getDomainFilter } from '@/utils/common/tableFilter'
import { arrayToObj, arrToObjByKey } from '@/utils/utils'
import currencyRequest from '@Bill/mixins/currencyRequest'
import ColumnsMixin from '../mixins/columns'

const RuleTypesMap = arrayToObj(RuleTypes, 'key')

export default {
  name: 'SuggestAlertRulesList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, currencyRequest],
  props: {
    id: String,
    cloudEnv: {
      type: String,
    },
    getParams: {
      type: Object,
      default: () => ({}),
    },
    hiddenColumns: {
      type: Array,
      default: () => ([]),
    },
    hiddenGroupBy: {
      type: Boolean,
    },
  },
  data () {
    let ruleScope = 'cost'
    if (this.$route.path.startsWith('/iam')) {
      ruleScope = 'security'
    }

    return {
      ruleScope: ruleScope,
      list: this.$list.createList(this, {
        id: this.id,
        apiVersion: 'v1',
        resource: 'suggestsysalerts',
        getParams: this.getParam,
        steadyStatus: Object.values(expectStatus.suggestsysalert).flat(),
        filterOptions: {
          name: {
            label: this.$t('bill.text_72'),
            filter: true,
            formatter: val => {
              return `name.contains("${val}")`
            },
          },
          brand: getBrandFilter('compute_engine_brands'),
          projects: getTenantFilter(),
          cloudaccount: getAccountFilter(),
          project_domains: getDomainFilter(),
          type: {
            label: this.$t('bill.text_173'),
            // filter: true,
            dropdown: true,
            distinctField: {
              type: 'extra_field',
              key: 'type',
              getParams: this.getParam,
            },
            // formatter: val => {
            //   return `type.contains("${val}")`
            // },
            mapper: list => {
              return list.map(({ key, label }) => {
                return {
                  key,
                  label: RuleTypesMap[key] ? RuleTypesMap[key].label : label,
                }
              })
            },
          },
        },
        hiddenColumns: ['name', 'type', 'account'],
      }),
      exportDataOptions: {
        items: [
          { label: 'ID', key: 'id' },
          { label: this.$t('bill.text_72'), key: 'res_name' },
          { label: this.$t('bill.text_212'), key: 'type' },
          { label: this.$t('bill.text_89'), key: 'status' },
          { label: this.$t('bill.text_174'), key: 'rule_name' },
          { label: this.$t('bill.text_182'), key: 'amount' },
          { label: this.$t('dictionary.project'), key: 'project' },
          { label: this.$t('bill.text_81'), key: 'hypervisor' },
          { label: this.$t('bill.text_60'), key: 'manager' },
          { label: this.$t('bill.text_83'), key: 'region' },
        ],
      },
      groupActions: [
        {
          label: this.$t('bill.text_269'),
          permission: 'suggestsysalerts_perform_ignore',
          action: (obj) => {
            const columnsMap = arrToObjByKey(this.columns, 'field')
            this.createDialog('IgnoreDialog', {
              vm: this,
              data: this.list.selectedItems,
              columns: [columnsMap.res_name.data, columnsMap.type.data, columnsMap.rule_name.data, columnsMap.suggest.data],
              onManager: this.onManager,
              refresh: this.refresh,
              success: () => {
                this.destroySidePage(this.windowId)
              },
            })
          },
          meta: (obj) => {
            const validate = this.list.selectedItems.length
            return {
              validate,
              tooltip: !validate ? this.$t('bill.subscription_validate_delete') : '',
            }
          },
        },
      ],
      group_by: 'type',
      groupByOpts: [
        { id: 'type', name: this.$t('meter.rule_group_by_type') },
        { id: 'res', name: this.$t('meter.rule_group_by_res') },
      ],
    }
  },
  computed: {
    showColumns () {
      return this.columns.filter(item => {
        let ret = this.group_by === 'type' ? true : !item.isResHide
        if (this.hiddenColumns.includes(item.field)) ret = false
        return ret
      })
    },
  },
  watch: {
    cloudEnv (val) {
      this.$nextTick(() => {
        this.list.fetchData(0)
      })
    },
    currencyParams: {
      handler: function () {
        this.list.fetchData()
      },
      deep: true,
    },
    group_by () {
      this.list.refresh()
    },
  },
  created () {
    this.initSidePageTab('suggestsalert-detail')
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        rule_scope: this.ruleScope,
        ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
        exchanged_currency: this.currencyParams.exchanged_currency,
      }
      if (this.group_by === 'res') {
        ret.group_by = ['res_type', 'res_id']
      }
      if (this.cloudEnv) ret.cloud_env = this.cloudEnv
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'SuggestsAlertSidePage', {
        id: row.id,
        resource: 'suggestsysalerts',
        apiVersion: 'v1',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
    openSuggestAlertDialog (obj) {
      this.createDialog('SuggestsAlertDeleteDialog', {
        data: [obj],
        columns: this.showColumns,
        onManager: this.onManager,
      })
    },
  },
}
</script>
